import { prop } from 'ramda';
import { useCallback } from 'react';
import { useAppSelector } from 'js/store/hooks';

import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useCheckUsernameAvailability = () => {
    const send = useGenericSend();
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback(
        async (request: Types.ICheckUsernameAvailabilityRequestData): Promise<Types.ICheckUsernameAvailabilityResponseData> => {
            const {
                data
            } = await send<Types.ICheckUsernameAvailabilityRequestData, Types.ICheckUsernameAvailabilityResponseData>({
                ID: 31003,
                responses: [31004, 33007],
                description: 'Check Username Availability Request',
                errorLevel: 1,
                ...request,
                casinoName
            });

            return data;
        }, [
            casinoName,
            send
        ]);
};
